<style lang="scss">
  .cartContent {
    p {
      strong {
        font-size: 16px;
      }
    }
    #szallitasi-mod.hasError {
      color: #DF3132;
    }
    form .custom-control.custom-radio .custom-control-label {
      padding-left: 40px;
      p {
        margin: 0;
      }
    }
    .foxpostAddress {
      padding: 20px 0 0 40px;
      height: 1px;
      -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -ms-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;
      overflow: hidden;
      &.fpVisible {
        height: 210px;
      }
      @media (min-width: 768px) {
        &.fpVisible {
          height: 140px;
        }
      }
      @media (min-width: 1200px) {
        &.fpVisible {
          height: 70px;
        }
      }
      .dropdown {
        margin-right: 20px;
        margin-bottom: 20px;
        padding-right: 15px;
        padding-left: 15px;
        text-transform: none;
        background-color: #fafafa;
        border: 2px solid #eaeaea;
      }
    }
    .formBottomGrid {
      .custom-control.custom-checkbox:last-of-type {
        margin-bottom: 50px;
      }
      .btn {
        width: 100%;
        margin: 10px 0;
      }
    }
    @media (min-width: 576px) {
      form .custom-control.custom-radio .custom-control-label,
      .foxpostAddress {
        padding-left: 60px;
      }
      .formBottomGrid {
        display: grid;
        grid-template-columns: 1fr 270px !important;
        grid-gap: 40px;
        margin: 40px 0 0 0;
        .btn {
          width: 270px;
          margin: 0;
        }
      }
    }
  }
</style>
<template>
  <div>
    <FrontendNav></FrontendNav>
    <div class="cartContent">
      <div class="container">
      <h1>Rendelési adatok</h1>
      <p class="orderProgress">
        <span class="active">Rendelés adatok</span> <i></i> <span>Fizetés</span> <i></i> <span>Összegzés</span>
      </p>
      <form>
        <p id="szallitasi-adatok"><strong>Szállítási adatok</strong></p>
        <p class="errors" v-if="fieldErrors.length">Kérjük, adja meg az alábbi mezőket: <span v-for="(error, index) in fieldErrors" :key="index">{{ error }}</span></p>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.lastname }">
              <input type="text" class="form-control" id="lastname" name="lastname" v-model="orderForm.lastname" v-bind:class="{'hasValue': orderForm.lastname !== ''}">
              <label for="lastname">Vezetéknév</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.firstname }">
              <input type="text" class="form-control" id="firstname" name="firstname" v-model="orderForm.firstname" v-bind:class="{'hasValue': orderForm.firstname !== ''}">
              <label for="firstname">Keresztnév</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.email }">
              <input type="email" class="form-control" id="email" name="email" v-model="orderForm.email" v-bind:class="{'hasValue': orderForm.email !== ''}">
              <label for="name">E-mail</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.tel }">
              <input type="tel" class="form-control" id="tel" name="tel" v-model="orderForm.tel" v-bind:class="{'hasValue': orderForm.tel !== ''}">
              <label for="tel">Telefon</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.country }">
              <input type="text" class="form-control" id="country" name="country" v-model="orderForm.country" v-bind:class="{'hasValue': orderForm.country !== ''}">
              <label for="country">Ország</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.zip }">
              <input type="text" class="form-control" id="zip" name="zip" v-model="orderForm.zip" v-bind:class="{'hasValue': orderForm.zip !== ''}">
              <label for="zip">Irányítószám</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.city }">
              <input type="text" class="form-control" id="city" name="city" v-model="orderForm.city" v-bind:class="{'hasValue': orderForm.city !== ''}">
              <label for="city">Város</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
              <input type="text" class="form-control" id="address" name="address" v-model="orderForm.address" v-bind:class="{'hasValue': orderForm.address !== ''}">
              <label for="address">Utca, házszám</label>
            </div>
          </div>
        </div>
        <p style="margin-bottom: 20px" id="szallitasi-mod" v-bind:class="{ hasError: errors.shipping }"><strong>Szállítási mód</strong></p>
        <div v-for="(sOption, index) in shippingOptions" :key="index" class="custom-control custom-radio">
          <input type="radio" v-bind:id="'shipping_method_' + sOption.id" v-bind:value="sOption.id" name="shipping_method" v-model="orderForm.shipping" class="custom-control-input">
          <label class="custom-control-label" v-bind:for="'shipping_method_' + sOption.id"><strong>{{sOption.name}} <span style="white-space: nowrap">({{sOption.price}} Ft)</span></strong><br><span v-html="sOption.description"></span></label>
        </div>
        <div class="foxpostAddress" v-bind:class="{ fpVisible: orderForm.shipping === 3, hasError: errors.foxpost}">
          <select name="city" class="dropdown btn" v-model="orderForm.fpCity" @change="fpCityChange">
            <option :value="null">Város</option>
            <option v-for="(city, index) in foxpostOrganized" :key="index" v-bind:value="city.city" >{{city.city}}</option>
          </select>
          <select name="location" class="dropdown btn" v-model="orderForm.fpAddress" @change="fpAddressChange">
            <option :value="null">Átvevőpont</option>
            <option v-for="(address, index2) in fpAddresses" :key="index2" v-bind:value="address.address" >{{address.address}}</option>
          </select>
        </div>
        <div class="formBottomGrid">
          <div></div>
          <div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="newsletter" v-model="orderForm.newsletter">
              <label class="custom-control-label" for="newsletter">Feliratkozom a Hírelvélre</label>
            </div>
            <div class="custom-control custom-checkbox" v-bind:class="{ hasError: errors.terms }">
              <input type="checkbox" class="custom-control-input" id="terms" v-model="orderForm.terms">
              <label class="custom-control-label" for="terms">Elfogadom az <a href="/docs/aszf.pdf" target="_blank">ÁSZF</a>-et</label>
            </div>
            <div class="custom-control custom-checkbox" v-bind:class="{ hasError: errors.privacy }">
              <input type="checkbox" class="custom-control-input" id="privacy" v-model="orderForm.privacy">
              <label class="custom-control-label" for="privacy">Elfogadom az <a href="/docs/adatkezeles.pdf" target="_blank">Adatkezelési tájékoztatót</a>.</label>
            </div>
          </div>
          <div><a href="/kosar" class="btn btn-outline">Vissza</a></div>
          <div><a href="/rendeles/fizetes" class="btn btn-primary" @click="validate($event)">Tovább</a></div>
        </div>
      </form>
    </div>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'

var VueScrollTo = require('vue-scrollto')

export default {
  name: 'OrderData',
  components: {
    FrontendNav,
    FrontendFooter
  },
  data: function () {
    return {
      fieldErrors: [],
      errors: {
        lastname: false,
        firstname: false,
        email: false,
        tel: false,
        country: false,
        zip: false,
        city: false,
        address: false,
        shipping: false,
        newsletter: false,
        terms: false,
        privacy: false
      },
      orderForm: {
        lastname: '',
        firstname: '',
        email: '',
        tel: '',
        country: '',
        zip: '',
        city: '',
        address: '',
        shipping: '',
        fpCity: null,
        fpAddress: null,
        fpId: '',
        terms: '',
        privacy: ''
      },
      shippingOptions: {},
      foxpost: [],
      foxpostOrganized: [],
      fpAddresses: []
    }
  },
  created: function () {
    if (localStorage.getItem('orderForm') !== null) {
      this.orderForm = JSON.parse(localStorage.getItem('orderForm'))
    }

    let url = process.env.API_URL + '/' + process.env.API_ENDPOINT
    this.$http
      .get(url + `/shipment-methods `, {
        'headers': {
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.shippingOptions = res.data.data
        this.foxpost = this.shippingOptions[0].foxpost
        for (let it in this.foxpost) {
          let have = false
          for (let xit in this.foxpostOrganized) {
            if (this.foxpostOrganized[xit].city === this.foxpost[it].city) {
              have = true
              this.foxpostOrganized[xit].addresses.push({address: this.foxpost[it].address, id: this.foxpost[it].id})
            }
          }
          if (!have) {
            this.foxpostOrganized.push({city: this.foxpost[it].city, addresses: [{address: this.foxpost[it].address, id: this.foxpost[it].id}]})
          }
        }

        if (this.orderForm.fpCity !== null) {
          for (let item in this.foxpostOrganized) {
            if (this.foxpostOrganized[item].city === this.orderForm.fpCity) {
              this.fpAddresses = this.foxpostOrganized[item].addresses
            }
          }
        }
      }).catch(res => {
      })
  },
  methods: {
    fpCityChange: function () {
      for (let item in this.foxpostOrganized) {
        if (this.foxpostOrganized[item].city === this.orderForm.fpCity) {
          this.fpAddresses = this.foxpostOrganized[item].addresses
          this.orderForm.fpAddress = null
        }
      }
    },
    fpAddressChange: function () {
      for (let item in this.foxpostOrganized) {
        if (this.foxpostOrganized[item].city === this.orderForm.fpCity) {
          for (let xit in this.foxpostOrganized[item].addresses) {
            if (this.foxpostOrganized[item].addresses[xit].address === this.orderForm.fpAddress) {
              this.orderForm.fpId = this.foxpostOrganized[item].addresses[xit].id
            }
          }
        }
      }
    },
    validate: function (e) {
      e.preventDefault()
      this.fieldErrors = []
      for (let key in this.errors) {
        this.errors[key] = false
      }
      if (this.orderForm.lastname === '') {
        this.fieldErrors.push('vezetéknév')
        this.errors.lastname = true
      }
      if (this.orderForm.firstname === '') {
        this.fieldErrors.push('keresztnév')
        this.errors.firstname = true
      }
      if (this.orderForm.email === '') {
        this.fieldErrors.push('e-mail')
        this.errors.email = true
      } else if (!this.validEmail(this.orderForm.email)) {
        this.fieldErrors.push('e-mail cím hibás')
        this.errors.email = true
      }
      if (this.orderForm.tel === '') {
        this.fieldErrors.push('telefon')
        this.errors.tel = true
      }
      if (this.orderForm.country === '') {
        this.fieldErrors.push('ország')
        this.errors.country = true
      }
      if (this.orderForm.zip === '') {
        this.fieldErrors.push('irányítószám')
        this.errors.zip = true
      }
      if (this.orderForm.city === '') {
        this.fieldErrors.push('város')
        this.errors.city = true
      }
      if (this.orderForm.address === '') {
        this.fieldErrors.push('utca, házszám')
        this.errors.address = true
      }
      if (this.orderForm.shipping === '') {
        this.fieldErrors.push('szállítási mód')
        this.errors.shipping = true
      }
      if (this.orderForm.terms !== true) {
        this.fieldErrors.push('ÁSZF')
        this.errors.terms = true
      }
      if (this.orderForm.privacy !== true) {
        this.fieldErrors.push('Adatkezelési tájékoztató')
        this.errors.privacy = true
      }
      if (this.orderForm.newsletter) {
        this.orderForm.newsletter = '1'
      }

      if (this.orderForm.shipping === 3 && (this.orderForm.fpId === null || this.orderForm.fpId === '')) {
        this.fieldErrors.push('Foxpost automata átvételi hely')
        this.errors.foxpost = true
      }

      if (this.fieldErrors.length > 0) {
        VueScrollTo.scrollTo('#szallitasi-adatok')
      } else {
        this.$store.commit('loading/setOrderData', this.orderForm)
        const parsed = JSON.stringify(this.orderForm)
        localStorage.setItem('orderForm', parsed)
        window.location.href = '/rendeles/fizetes'
      }
    },
    validEmail: function (email) {
      /* eslint-disable */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/order/data.vue